<template>
    <div>
        <v-toolbar dense color="primary" app :clipped-left="true" dark tabs>

            <v-btn icon @click="goBack()">
                <v-icon>arrow_back</v-icon>
            </v-btn>

            <v-toolbar-title>Cadastrar PacPon</v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn icon @click.stop="done()" :disabled="accuracy > limit || center.lat >= 0">
                <v-icon>done_all</v-icon>
            </v-btn>

        </v-toolbar>
        <main>
            <v-alert outline color="error" icon="warning" :value="error">
                {{error}}
            </v-alert>
            <div id="map" style="height: calc(100vh - 138px)"></div>
            <v-alert outline color="error" icon="error" :value="accuracy > limit" >
                Proximidade: {{accuracy}}m <br/> lat & lng {{out}}
            </v-alert>
            <v-alert outline color="success" icon="check_circle" :value="accuracy <= limit && center.lat < -0">
                Já pode avançar!<br/>
                Clique no ícone: <v-icon>done_all</v-icon> acima.
            </v-alert>
        </main>
    </div>
</template>

<script>
    /* global L */
    export default {
        name: "CadastrarCaixa",
        data () {
            return {
                limit: 2200,
                out: null,
                maps: null,
                marker: null,
                error: null,
                accuracy: null,
                center: { lat: 0.0, lng: 0.0 },
                watchID: null
            };
        },

        beforeMount () {
            if (!navigator.geolocation) {
                alert("Geolocation not is supported!");
            } else {
                this.openLatLong();
            }
        },
        beforeDestroy () {
            if (this.watchID) {
                navigator.geolocation.clearWatch(this.watchID);
            }
        },
        mounted () {
            this.createMap();
        },
        methods: {
            goBack: function () {
                this.$router.push("/");
            },
            createMap () {
                setTimeout(() => {
                    this.map = L.map(document.getElementById("map"), {
                        center: [this.center.lat, this.center.lng],
                        zoom: 16
                    });

                    let layerGoogle = L.tileLayer('https://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga', {
                        attribution: '&copy; OpenStreetMap contributors'
                    });

                    let layerOSM = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        attribution: '&copy; OpenStreetMap contributors'
                    });

                    layerGoogle.addTo(this.map);

                    let baseMaps = {
                        " &nbsp;Cartográfico": layerOSM,
                        ' &nbsp;Satélite': layerGoogle
                    };

                    L.control.layers(baseMaps).addTo(this.map);

                    this.marker = L.marker([this.center.lat, this.center.lng])
                        .addTo(this.map);
                }, 1000);
                /*
                this.map = new google
                    .maps
                    .Map(document.getElementById("map"), {
                        zoom: 15,
                        gestureHandling: "greedy",
                        center: this.center,
                        draggableCursor: "auto",
                        streetViewControl: false,
                        draggingCursor: "move",
                        disableDoubleClickZoom: false
                    });

                // eslint-disable-next-line no-new
                this.marker = new google.maps.Marker({
                    position: this.center,
                    map: this.map,
                    title: "Meu local"
                })
                */
            },
            done: async function () {
                this.$router.push("/cadastrar/caixa/" + this.center.lat + "/" + this.center.lng);
            },
            openLatLong: function () {
                this.dialog = false;
                this.watchID = navigator
                    .geolocation
                    .watchPosition(
                        this.processGeolocation,
                        this.geolocationError,
                        {
                            enableHighAccuracy: true,
                            timeout: 3000,
                            maximumAge: 0
                        }
                    );
            },
            processGeolocation: function (position) {
                console.log(position);
                this.out = position.coords.latitude + "," + position.coords.longitude;
                this.center = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };

                if (this.marker) {
                    this.marker.setLatLng(this.center);
                }

                if (this.map) {
                    this.map.setView(this.center);
                }

                this.accuracy = position.coords.accuracy;
            },
            geolocationError: function (error) {
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        this.error = "User denied the request for Geolocation.";
                        break;
                    case error.POSITION_UNAVAILABLE:
                        this.error = "Location information is unavailable.";
                        break;
                    case error.TIMEOUT:
                        this.error = "The request to get user location timed out.";
                        break;
                    case error.UNKNOWN_ERROR:
                        this.error = "An unknown error occurred.";
                        break;
                }
            }
        }
    }
</script>

<style scoped>

</style>
